import { ALL_LNGS_NAMESPACES, LNGS_NAMESPACE_CALL_LOGS } from '@ingenico/util-i18n-config';
import { CoreChip } from '@ingenico/react-ui/core-chip';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { getDeviceLabel, isPrimaryDevice } from '../ParameterOutputFileModal.util';
import type { DeviceOptionProps } from './DeviceOption.model';
import styles from './DeviceOption.module.scss';

export function DeviceOption({ device }: DeviceOptionProps): ReactNode {
  const { t } = useTranslation(Object.values(LNGS_NAMESPACE_CALL_LOGS));
  const deviceLabel = getDeviceLabel(device);

  return (
    <div className={styles.deviceOption}>
      <CoreTypography
        customClassName={styles.deviceOption__name}
        showTooltip
        tooltipTitle={deviceLabel}
        truncateText
        variant={CoreTypographyVariant.Body02Regular}
      >
        {deviceLabel}
      </CoreTypography>
      {isPrimaryDevice(device) && (
        <CoreChip
          className={styles.deviceOption__chip}
          label={t('sections.parameterOutputFile.modal.label.primary', {
            ns: ALL_LNGS_NAMESPACES.CALL_LOGS,
          })}
          color="primary"
        />
      )}
    </div>
  );
}
